import {FAILURE, PENDING, SUCCESS} from '../../constants'
import fixture from '../../../fixtures/reservations/get-configurations.json'
import {getConfigurations as getConfigurationsAPI} from '../../../services/reservations/reservationConfiguration'
export async function getConfigurations(dispatch) {
  try {
    dispatch({type: PENDING})
    //TODO: actual api
    let response = await getConfigurationsAPI()
    dispatch({type: SUCCESS, payload: response})
    return response
  } catch (e) {
    console.log(`Get Reservation Configurations Failed`)
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}
